import {inflector} from '@amblique/king-living/shared/helpers/inflector';

/** Preset key in {@link VIDEO_OPTIONS}.mediaCarousel */
export const MEDIA_CAROUSEL_VIDEO_PRESET = 'mediaCarousel';

/**
 * Prefix carousel preset before Contentful Video `presets` (Hero, Interactive, …).
 * CMS preset is camelized and listed second so it wins in the video options resolver.
 *
 * @param {string|null|undefined} cmsPresets - Contentful enum: Hero | Interactive | Product Gallery | Product Tile
 * @returns {string}
 */
export function mergeVideoPresets(cmsPresets) {
  if (typeof cmsPresets !== 'string' || !cmsPresets.trim()) {
    return MEDIA_CAROUSEL_VIDEO_PRESET;
  }

  return `${MEDIA_CAROUSEL_VIDEO_PRESET},${inflector.camelize(cmsPresets.trim())}`;
}

/**
 * Apply the media-carousel video preset to slide Video entries.
 *
 * @param {object} slideComponent
 * @returns {object}
 */
export function withMediaCarouselVideoPreset(slideComponent) {
  if (!slideComponent) {
    return slideComponent;
  }

  if (slideComponent.__typename === 'Video') {
    return {
      ...slideComponent,
      presets: mergeVideoPresets(slideComponent.presets),
    };
  }

  if (slideComponent.__typename === 'CarouselItem' && slideComponent.media?.__typename === 'Video') {
    return {
      ...slideComponent,
      media: {
        ...slideComponent.media,
        presets: mergeVideoPresets(slideComponent.media.presets),
      },
    };
  }

  return slideComponent;
}
